import { useState, type FormEvent } from 'react'
import { Link } from '@tanstack/react-router'
import { Alert, AuthCard, Button, Field } from '../components/ui'
import { useRegister } from '../lib/session'

// Doit suivre la configuration par defaut de la WebApi (Auth:PasswordMinimumLength).
export const passwordHint =
  '12 caracteres minimum, avec au moins une minuscule, une majuscule et un chiffre.'

export default function RegisterPage() {
  const register = useRegister()

  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const mismatch = confirmation.length > 0 && password !== confirmation

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (password !== confirmation) {
      return
    }

    register.mutate({ email, password, displayName })
  }

  if (register.isSuccess) {
    return (
      <AuthCard title="Verifiez votre boite de reception">
        <Alert tone="success">
          Votre compte est cree. Un e-mail de confirmation a ete envoye a {email}. Ouvrez le lien
          qu'il contient pour activer votre compte.
        </Alert>
        <p className="mt-6 text-center text-sm">
          <Link to="/login" className="font-medium underline underline-offset-4">
            Retour a la connexion
          </Link>
        </p>
      </AuthCard>
    )
  }

  return (
    <AuthCard title="Creer un compte" subtitle="Un e-mail vous sera envoye pour confirmer votre adresse.">
      <form onSubmit={onSubmit} className="space-y-4">
        <Field
          label="Nom affiche"
          name="displayName"
          autoComplete="name"
          required
          value={displayName}
          onChange={(event) => setDisplayName(event.target.value)}
        />
        <Field
          label="Adresse e-mail"
          type="email"
          name="email"
          autoComplete="username"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <Field
          label="Mot de passe"
          type="password"
          name="password"
          autoComplete="new-password"
          required
          minLength={12}
          hint={passwordHint}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <Field
          label="Confirmation du mot de passe"
          type="password"
          name="confirmation"
          autoComplete="new-password"
          required
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
        />

        {mismatch && <Alert>Les deux mots de passe sont differents.</Alert>}
        {register.isError && <Alert>{register.error.message}</Alert>}

        <Button type="submit" disabled={register.isPending || mismatch}>
          {register.isPending ? 'Creation...' : 'Creer le compte'}
        </Button>
      </form>

      <p className="mt-6 text-center text-sm text-neutral-600 dark:text-neutral-400">
        Deja inscrit ?{' '}
        <Link to="/login" className="font-medium underline underline-offset-4">
          Se connecter
        </Link>
      </p>
    </AuthCard>
  )
}
